import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/pages/Layout";
import Splash from "@/pages/Splash";
import Home from "@/pages/Home";
import Presets from "@/pages/Presets";
import Builder from "@/pages/Builder";
import Settings from "@/pages/Settings";
import ActiveWorkout from "@/pages/ActiveWorkout";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(30,41,59,0.95)",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#fff",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Splash />} />
          <Route path="/workout/:id" element={<ActiveWorkout />} />
          <Route element={<Layout />}>
            <Route path="/home" element={<Home />} />
            <Route path="/presets" element={<Presets />} />
            <Route path="/builder" element={<Builder />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
